import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useGymAdmin } from '../context/gym-admin-context';

/**
 * Where the scoreboard used to live. A round *is* its board now, so
 * `/rounds/:id/scores` is `/rounds/:id` — and links to the old one are out in
 * the world, in a browser's history and in messages to the desk, so they are
 * moved rather than broken.
 *
 * **The search goes with them.** The open class and the typed filter live there
 * (`?category=&q=`), and a link to one class's board that lands on another's has
 * not really been kept.
 */
export default function RoundScoresRedirect() {
  const { roundId } = useParams<{ roundId: string }>();
  const { search } = useLocation();
  const { placePath } = useGymAdmin();

  return <Navigate to={`${placePath(`/rounds/${roundId}`)}${search}`} replace />;
}
